import { createContext } from 'react';

type CajaFlowDataContext = {
  loading: boolean;
};

export const EditFlowDataContext = createContext<CajaFlowDataContext>({
  loading: true,
});

export const RefreshFlowDataContext = createContext<CajaFlowDataContext>({
  loading: true,
});

export const MultiLocationDataContext = createContext<CajaFlowDataContext>({
  loading: true,
});
